let colorObj = {
    /**
     * 相电压
    */
    10301: '#FADB14', //相电压Uab
    10302: '#52C41A', //线电压Ubc
    10303: '#F5222D', //线电压Uac
    10304: '#FADB14', //相电压Uan
    10305: '#52C41A', //相电压Ubn
    10306: '#F5222D', //相电压Ucn
    10313: '#1EC1DE', //Uabc
    /**
     * 电流
     */
    10201: '#FADB14', //电流la  
    10202: '#52C41A', //电流lb
    10203: '#F5222D', //电流Ic
    10204: '#1890FF', //零序电流In
    10206: '#1EC1DE', //合相电流Iabc
    /**
     * 温度
     */
    10101: '#FADB14', //温度Ta
    10102: '#52C41A', //温度Tb
    10103: '#F5222D', //温度Tc
    10104: '#1890FF', //温度Tn
    10105: '#1EC1DE', //温度To
    /**
     * 26路测温颜色组
     */
     colorGroup: ['#EB2F96','#1890FF','#722ED1','#F5222D','#52C41A','#FADB14'],
     /**
      * 功率
      */
     10401: '#1890FF', //总有功功率
     10402: '#FADB14', //A相有功功率
     10403: '#52C41A', //B相有功功率
     10404: '#F5222D', //C相有功功率
     10501: '#1890FF', //无功功率
     10502: '#FADB14', //A相无功功率
     10503: '#52C41A', //B相无功功率
     10504: '#F5222D', //C相无功功率
     10601: '#1890FF', //视在功率
     10602: '#FADB14', //A相视在功率
     10603: '#52C41A', //B相视在功率
     10604: '#F5222D', //C相视在功率
     /**
      * 功率因数
      */
     10800: '#1890FF', //功率因数
     10801: '#FADB14', //A相功率因数
     10802: '#52C41A', //B相功率因数
     10803: '#F5222D', //C相功率因数
     /**
      * 频率
      */
     10700: '#1890FF', //频率
     /**
      * 漏电电流
      */
     10901: '#1890FF', //漏电点流
     /**
      * 电度
      */
     30101: '#1890FF', //总正向有功电度
     30102: '#1EC1DE', //总正向无功电度
}
export default colorObj



// WEBPACK FOOTER //
// ./src/assets/js/color-configure.js